import "./make.scss";
import { useNavigate, useLocation, Link } from "react-router-dom";

const Make = () => {
  const navigate = useNavigate();

  const donatepage = () => {
    navigate("/donatenow");
  };
  return (
    <div>
      <div className="make-box">
        <h1>Give with love and make a difference.</h1>
        <p>Your generosity brings hope where it's needed most.</p>
        <div className="make-button-section">
          <button className="make-donate" onClick={donatepage}>Donate Now</button>
          <button className="make-becomebutton">Become A Volunteer</button>
        </div>
      </div>
    </div>
  );
};
export default Make;
